import api from '#config/api';

export const getSettings = () => api.get('/settings');
export const getScraperHealth = () => api.get('/scraper_health');
